import {z} from 'zod';
import {getReasonSchema} from '../../utils/schema.ts';
import type {TranslationFunction} from 'src/types/language-support.ts';


export const getIdentificationFlowSchema = (
  t: TranslationFunction,
  isReschedule: boolean,
) => {
  const reasonSchema = getReasonSchema(t);
  return z.discriminatedUnion('participantType', [
    z.object({
      participantType: z.literal('CANDIDATE'),
      reason: z.string().optional(),
    }),
    z.object({
      participantType: z.literal('HOST'),
      reason: isReschedule ? reasonSchema : z.string().optional(),
    }),
    z.object({
      participantType: z.literal('MEETING_COORDINATOR'),
      reason: isReschedule ? reasonSchema : z.string().optional(),
    }),
  ]);
};
